export default function Steam() {
  return (
    <div
      className="ion-icon-steam"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<style type="text/css">
<![CDATA[
	.st0{fill:#010101;}
]]>
</style>
<path id="Gears" class="st0" d="M480,208.2c0,20.5-16.6,37.2-37.2,37.2c-20.5,0-37.2-16.6-37.2-37.2c0-20.5,16.6-37.2,37.2-37.2
	C463.3,171,480,187.7,480,208.2z M442.6,139c-38.1,0-69,30.7-69.4,68.7L330,269.7c-1.8-0.2-3.6-0.3-5.4-0.3
	c-9.7,0-18.7,2.7-26.4,7.3l-195.8-78.7c-5.1-23.2-25.9-40.7-50.6-40.7C23.3,157.2,0,180.6,0,209.1c0,28.5,23.3,51.8,51.8,51.8
	c9.7,0,18.7-2.7,26.4-7.3L274,332.2c5.1,23.3,25.8,40.8,50.6,40.8c26.8,0,49-20.6,51.5-46.7l66.5-48.6c38.3,0,69.4-31,69.4-69.3
	C512,170.1,480.9,139,442.6,139z M442.6,161.9c25.7,0,46.5,20.9,46.5,46.5c0,25.7-20.9,46.4-46.5,46.4c-25.7,0-46.5-20.8-46.5-46.4
	C396.1,182.7,416.9,161.9,442.6,161.9z M51.8,170.9c14.6,0,27.3,8.2,33.7,20.2l-18.9-7.6v0.1c-15.3-5.5-32.2,2-38.3,17.1
	c-6.1,15.2,0.9,32.3,15.7,38.9v0.1l16.1,6.4c-2.6,0.6-5.4,0.9-8.2,0.9c-21.1,0-38.1-17-38.1-38.1C13.7,188,30.7,170.9,51.8,170.9z
	 M324.6,283.1c21.1,0,38.1,17,38.1,38.1c0,21.1-17,38.1-38.1,38.1c-14.7,0-27.4-8.2-33.7-20.3c6.3,2.5,12.5,5,18.8,7.6
	c15.5,6.2,33.2-1.3,39.4-16.8c6.2-15.5-1.3-33.1-16.9-39.4l-15.9-6.4C319.1,283.5,321.8,283.1,324.6,283.1z"/>
</svg>
`,
      }}
    />
  )
}
